module.exports = __webpack_public_path__ + "img/er.804cbeb.svg";